import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';
import { useAppDispatch } from '../../app/hooks';
import { toggleSidebar } from '../../features/ui/uiSlice';

/** Live-revenue pill shown at the right of the header. */
export function StatPill({ label, value, live = false }) {
  return (
    <Box
      sx={{
        border: '1px solid var(--border)',
        background: 'var(--card)',
        borderRadius: '12px',
        p: '8px 14px',
        boxShadow: 'var(--shadow)',
        fontFamily: 'var(--mono)',
        fontSize: 11,
        letterSpacing: '.06em',
        color: 'var(--ink-2)',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
      }}
    >
      <Box
        component="b"
        sx={{
          fontFamily: 'var(--disp)',
          fontSize: 20,
          color: live ? 'var(--mint)' : 'var(--ink)',
          display: 'block',
          lineHeight: 1,
        }}
      >
        {value}
      </Box>
      {label}
    </Box>
  );
}

export default function Topbar({ crumbs, title, subtitle, actions }) {
  const dispatch = useAppDispatch();

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <ButtonBase
          onClick={() => dispatch(toggleSidebar())}
          sx={{
            display: 'none',
            border: '1px solid var(--border)',
            background: 'var(--card)',
            borderRadius: '10px',
            width: 40,
            height: 40,
            fontSize: 18,
            '@media (max-width:920px)': { display: 'block' },
          }}
        >
          ☰
        </ButtonBase>
        <Box
          sx={{
            fontFamily: 'var(--mono)',
            fontSize: 11,
            letterSpacing: '.1em',
            color: 'var(--muted)',
            textTransform: 'uppercase',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            flexWrap: 'wrap',
            '& b': { color: 'var(--tealdim)' },
          }}
        >
          {crumbs}
        </Box>
      </Box>

      {/* Header is itself a 12-column row: identity on the left, controls on the right. */}
      <Grid container spacing={2} sx={{ alignItems: 'flex-end', m: '6px 0 22px' }}>
        <Grid size={{ xs: 12, md: 6, lg: 7 }}>
          <Typography
            component="h1"
            sx={{
              fontFamily: 'var(--disp)',
              fontWeight: 700,
              fontSize: { xs: 26, md: 34 },
              letterSpacing: '-.01em',
              m: '2px 0 0',
              textTransform: 'uppercase',
              lineHeight: 1.1,
            }}
          >
            {title}
          </Typography>
          <Box sx={{ fontSize: 13, color: 'var(--ink-2)' }}>{subtitle}</Box>
        </Grid>
        <Grid size={{ xs: 12, md: 6, lg: 5 }}>
          <Box
            sx={{
              display: 'flex',
              gap: 1.25,
              alignItems: 'center',
              flexWrap: 'wrap',
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
            }}
          >
            {actions}
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
